import axios from "@axios";

export default {
  generate(data) {
    return axios.post("/profissional/atendimento/parecer_cardiologicos", data);
  },
  salvarExameFisico(data) {
    return axios.put(
      `/profissional/atendimento/parecer_cardiologicos/exame_fisico/${data.id}`,
      data
    );
  },
  salvarSimtomatologia(data) {
    return axios.put(
      `/profissional/atendimento/parecer_cardiologicos/sintomatologia/${data.id}`,
      data
    );
  },
  salvarFatorDeRisco(data) {
    return axios.put(
      `/profissional/atendimento/parecer_cardiologicos/fator_risco/${data.id}`,
      data
    );
  },
  getById(id) {
    return axios.get(`/profissional/atendimento/parecer_cardiologicos/${id}`);
  },
  getPatientById(id) {
    return axios.get(
      `/profissional/atendimento/parecer_cardiologicos/paciente/${id}`
    );
  },
  updateFatorRisco(data) {
    return axios.put(
      `/profissional/atendimento/parecer_cardiologicos/fator_risco/${data.id}`,
      data
    );
  },
  updateSintomaTologia(data) {
    return axios.put(
      `/profissional/atendimento/parecer_cardiologicos/sintomatologia/${data.id}`,
      data
    );
  },
  updateExameFisico(data) {
    return axios.put(
      `/profissional/atendimento/parecer_cardiologicos/exame_fisico/${data.id}`,
      data
    );
  },
  salvarRecomendacao(data) {
    return axios.put(
      `/profissional/atendimento/parecer_cardiologicos/recomendacao/${data.id}`,
      data
    );
  },
  salvarExamesComplementares(data) {
    return axios.put(
      `/profissional/atendimento/parecer_cardiologicos/exame_complementares/${data.id}`,
      data
    );
  },
  salvarConclusao(data) {
    return axios.put(
      `/profissional/atendimento/parecer_cardiologicos/conclusao/${data.id}`,
      data
    );
  },
  salvarMedicamentoEmUso(data) {
    return axios.put(
      `/profissional/atendimento/parecer_cardiologicos/medicamento_em_uso/${data.id}`,
      data
    );
  },
  imprimirRelatorio(data) {
    // Aponta direto para a API de report externa ou envia proxy via seu app backend
    // Assumindo uso das envs VUE_APP_URL_API_REPORT
    const apiUrl = process.env.VUE_APP_URL_API_REPORT;
    const apiKey = process.env.VUE_APP_API_KEY_REPORT;

    return axios.post(
      apiUrl,
      {
        template: "parecer_cardiologico.html",
        dados: { atendimento_id: data.atendimento_id }
      },
      {
        headers: {
          "X-API-KEY": apiKey,
        },
        responseType: "blob", // Importante para o arquivo PDF vindo via StreamingResponse
      }
    );
  },
};
